import { Carousel } from 'react-bootstrap';
import { useState } from 'react';

import Lottie from 'lottie-react';
import animationData from '../../../components/lottieFiles/animation-4.json';

const swiperImages = [
  "images/banner-1.jpeg",
  "images/banner-2.jpg",
  "images/banner-3.jpeg",
  "images/banner-4.jpeg",
  "images/banner-5.jpeg",
]

const HomeSection8 = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  return (
    <div className='padding_t88'>
      <div className='d-flex w-100 show_on_mobile'>
        <input className='search_bar w-100' type="text" placeholder='Search for jeans, t-shirts, dresses, jackets, or brands...' />
        <button className='search_btn item_center'>
          <img className='search_icon' src="images/search-icon.svg" alt="" />
        </button>
      </div>
      <div className='hero_crousel_wrapper'>
        <Carousel activeIndex={index} onSelect={handleSelect}>
          {swiperImages.map((item, index) => {
            return (
              <Carousel.Item key={index}>
                <img className='slide_img' src={item} alt='img' />
              </Carousel.Item>
            )
          })}

        </Carousel>
        {/* Fixed Center Content */}
        <div
          className="position-absolute top-50 start-50 translate-middle text-white text-center z-1 hide_on768"
        >
          <div className="blur_layer d-flex gap-2 flex-column text-white">
            <div className='lottie-container'>
              <Lottie className='lottie' animationData={animationData} loop={true} />
            </div>
            <div>
              <h1 className="search_title title-md fw-bold mb-0 text-uppercase">Find Your Perfect Look.</h1>
              <p className="lead title-xs text-muted mb-2">
                Discover the latest trends for men, women, and kids. Search styles, brands, or clothing types.
              </p>
            </div>
            <div className='d-flex w-100'>
              <input className='search_bar w-100' type="text" placeholder='Search for jeans, t-shirts, dresses, jackets, or brands...' />
              <button className='search_btn item_center'>
                <img className='search_icon' src="images/search-icon.svg" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default HomeSection8